import React, {Component} from 'react'
import loadGoogleMapsAPI from 'load-google-maps-api-2'

const APIKEY = 'AIzaSyBPoJuCDWoVLw1uSNoHToQPbKyk8h0m5Rs'

export default class Map extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    console.log('Props: ' + JSON.stringify(this.props))
    const LOCATION = {
      lat: this.props.location.coordinates[1], //lng
      lng: this.props.location.coordinates[0], //lat
    }
    console.log('LOCATION: ' + JSON.stringify(LOCATION))

    loadGoogleMapsAPI({key: APIKEY})
      .then(googleMaps => {
        console.log(googleMaps) //=> Object { Animation: Object, ...
        this.map = new googleMaps.Map(this.refs.map, {
          center: LOCATION,
          zoom: 16,
        })

        this.marker = new googleMaps.Marker({
          position: new googleMaps.LatLng(LOCATION.lng, LOCATION.lat),
          map: this.map,
        })
      })
      .catch(err => {
        console.error(err)
      })
  }

  render() {
    const mapStyle = {
      width: 500,
      height: 300,
      border: '1px solid black',
    }

    return (
      <div>
        <div ref="map" style={mapStyle}>Loading...</div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/map/googlemap.js
 **/